import { render, staticRenderFns } from "./ResourceRequest.vue?vue&type=template&id=026c2f99"
import script from "./ResourceRequest.vue?vue&type=script&lang=js"
export * from "./ResourceRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports